import { Stack } from '@mui/material'
import ProductDraftItem from 'components/ProductRows/ProductDraftItem'
import React from 'react'
import { CustomProductDraft } from 'types'
const ProductDraftList = ({
  drafts,
  onEditDraft,
  onRemoveDraft,
}: {
  drafts: CustomProductDraft[] | []
  onEditDraft: (id: string, patch: Partial<CustomProductDraft>) => void
  onRemoveDraft: (id: string) => void
}) => {
  React.useEffect(() => {
    console.log('drafts', drafts)
  }, [drafts])
  return (
    <Stack spacing={0} mt={1}>
      {drafts?.map(d => (
        <ProductDraftItem
          key={d.id}
          draft={d}
          onChange={patch => onEditDraft(d.id, patch)}
          onRemove={() => onRemoveDraft(d.id)}
        />
      ))}
    </Stack>
  )
}

export default ProductDraftList
